import { Link } from "react-router-dom";
import type { Notification } from "@circle-react/types/Notification";
import { DefaultNotificationContent } from "./DefaultNotificationContent";

export const DefaultNotification = ({
  notification,
  onClickHandler,
  isMarkedAsRead,
}: {
  notification: Notification;
  onClickHandler: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  isMarkedAsRead: boolean;
}) => (
  <Link
    to={notification.action_web_path}
    onClick={onClickHandler}
    className="w-full"
  >
    <DefaultNotificationContent
      notification={notification}
      isMarkedAsRead={isMarkedAsRead}
    />
  </Link>
);
